import React from 'react';
import AnswerChecker from '../AnswerChecker';

interface IBunnySquaresProps {
  onNextGame: any
};

export const BunnySquares = (props:IBunnySquaresProps)=>{
  const {onNextGame} = props;

  return <div>
    <img src={`${process.env.PUBLIC_URL}/images/bunnysquares.png`} alt="A grid of overlapping squares"/>
    <br/>

    <p>How many bunnies are there?</p>

    <AnswerChecker onNextGame={onNextGame} correctAnswer="64565ab3a2cddb6908d76068f77e942821027dc6d81c4a4ae937e131d0bc71f5"/>
</div>;
}
